module.exports = __webpack_public_path__ + "img/p2.d9f9ccdd.png";